import { UntypedFormGroup } from '@angular/forms';
import { SimpleChanges } from '@angular/core';
import { Dto } from '@damofire/data-commons';

/** changeAuthorizedFields, Receives a form and an angularFireStoreDocument<T>.
 Changes all the the values of the forms, except for the one that the user is currently modifying.
 Make sure to use (blur) and (focus) to set the inputName value. */
export const changeAuthorizedFields = function <T>(form: UntypedFormGroup, doc: T, inputName: string) {
  const myObj: Object = doc;
  Object.keys(form.controls).forEach((key) => {
    if (myObj.hasOwnProperty(key)) {
      if (form.controls[key].value !== doc[key]) {
        if (key !== inputName) {
          form.controls[key].setValue(doc[key]);
        }
      }
    }
  });
};

export const angularPropertyChanged = (changes: SimpleChanges, docProp: string) => {
  return changes[docProp]?.currentValue && (!changes[docProp].previousValue || changes[docProp].currentValue !== changes[docProp].previousValue);
};

export const findDtoIndex = function <T extends Dto<any>>(array: T[], dto: T) {
  return array?.findIndex((v: T) => v?._id === dto?._id);
};
